import React, {useCallback, useState} from 'react';
import {AvatarProps} from './types';
import {Layout} from '../layout';
import {Text} from '../text';
import {useStyle} from '../base/hooks';
import {AvatarLayoutMap} from './styles';
import {useTheme} from '../../theme';
import {DefaultAvatar} from './assets/DefaultAvatar';

export const Avatar: React.FC<AvatarProps> = ({
  name,
  uri,
  shape = 'round',
  size = '36',
}) => {
  const theme = useTheme();
  const calculateInitials = (): string => {
    const initials = (name || 'N N').trim().split(' ');

    return initials[1]
      ? initials[0].charAt(0) + initials[initials.length - 1].charAt(0)
      : initials[0].charAt(0) + initials[0].charAt(1);
  };
  const layout = AvatarLayoutMap[size];
  const borderRadius = shape === 'round' ? '9999' : layout.borderRadius;

  const [hideImage, setHideImage] = useState(false);

  const hideImageStyle = useStyle(
    () =>
      hideImage
        ? {
            opacity: 0,
          }
        : {},
    [hideImage],
  );
  const renderDefaultAvatar = useCallback(() => {
    return (
      <Layout flex justify="center" centered absolute zIndex={1}>
        <DefaultAvatar
          height={layout.size}
          width={layout.size}
          theme={theme.time}
        />
      </Layout>
    );
  }, [layout.size, theme.time]);

  const handleOnError = () => {
    setHideImage(true);
  };
  return (
    <Layout
      backgroundColor={'background_mono_secondary'}
      borderRadius={borderRadius}
      width={layout.size}
      height={layout.size}
      overflow="hidden">
      {!name && !uri ? renderDefaultAvatar() : null}
      <Layout flex justify="center" centered absolute>
        <Text
          textColor="content_mono_secondary"
          align="center"
          variant={layout.textVariant}>
          {calculateInitials()}
        </Text>
      </Layout>
      {uri ? (
        <img
          className={hideImageStyle}
          style={{height: '100%', width: '100%', objectFit: 'fill', zIndex: 1}}
          src={uri}
          alt={name}
          onError={handleOnError}
        />
      ) : null}

      <Layout
        flex
        absolute
        borderRadius={borderRadius}
        borderWidth="1"
        borderStyle="solid"
        borderColor="border_mono_10"
        borderPosition="inside"
        zIndex={2}
        width={layout.size}
        height={layout.size}
      />
    </Layout>
  );
};
